<template>
  <o-table :title="$t('sandoz_sortalys.bezugs_statistik')" ref="tableList"
           url="/api/sandoz_sortalys/bezugsstatistik?include=uploader" :enable-new="false" :enable-edit="false"
           :enable-delete="false" default-sort-by-direction="desc" default-sort-by="ImportDate">
    <template slot="filter">
      <o-filter :default-filter="defaultFilter" v-on:filter-updated="(filters) => $refs.tableList.setFilters(filters)" :single="false">
        <o-filter-select :items="userList" :title="$t('sandoz_sortalys.uploader')" column="UploaderId" value-field="Id"
                         text-field="Name"></o-filter-select>
        <o-filter-text :title="$t('sandoz.customer_external_id')" column="CustomerExternalId"></o-filter-text>
        <o-filter-text :title="$t('sandoz.customer_name')" column="CustomerName"></o-filter-text>
      </o-filter>
    </template>
    <template slot="head">
      <o-table-header column="DirectLinkId">{{ $t('sandoz_sortalys.direct_link_id') }}</o-table-header>
      <o-table-header column="CustomerExternalId">{{ $t('sandoz.customer_external_id') }}</o-table-header>
      <o-table-header column="ImportDate">{{ $t('sandoz_sortalys.import_date') }}</o-table-header>
      <o-table-header column="uploader.Name">{{ $t('sandoz_sortalys.uploader') }}</o-table-header>
      <o-table-header column="CustomerName">{{ $t('sandoz_sortalys.customer_name') }}</o-table-header>
    </template>
    <template slot="body" slot-scope="props">
      <td>{{ props.item.DirectLinkId }}</td>
      <td>{{ props.item.CustomerExternalId }}</td>
      <td>{{ props.item.ImportDate | formatDate }}</td>
      <td>{{ props.item.uploader.data.Name }}</td>
      <td>{{ props.item.CustomerName }}</td>
    </template>
    <template slot="body-controls" slot-scope="props">
      <td class="text-right">
        <button class="btn btn-primary" @click.stop="openDashboard(props.item.DirectLinkId)">
          <fa icon="arrow-right"/>
        </button>
      </td>
    </template>
  </o-table>
</template>

<script>
import axios from 'axios'

export default {
  data: () => ({
    userList: [],
    defaultFilter: []
  }),
  created() {
    if(this.$route.query && this.$route.query.external_id) {
        this.defaultFilter = [{
        column: 'CustomerExternalId',
        displayValue: this.$route.query.external_id+'%',
        title: this.$i18n.t('sandoz.customer_external_id'),
        value: this.$route.query.external_id+'%',
      }]
    }
  },
  mounted() {
    axios.get('/api/sandoz_sortalys/user?sortBy=Name&per_page=99999').then((response) => {
      this.userList = response.data.data
    }).catch((error) => {
      console.error(error)
    })
  },
  methods: {
    openDashboard(directLinkId) {
      window.open('https://www.sortalys.ch/dashboard/' + directLinkId, '_blank');
    }
  }
}
</script>
